import React from 'react';
import "../About.css";


function Header() {
  return (
    <div>
        <header class="about-header">
          <h3>About Us</h3>
        </header>

        <section class="about-section">
          <p>
            Sickle Cell Awareness and Health Foundation is a non-profit organization that started in March 2018 as an awareness forum and<br/>
            was incorporated in January 2020. <br/>
          </p>

          <p>
            We are driven by two significant objectives: to amplify awareness on Sickle Cell Disorder (SCD) and to ensure that less privileged<br/> 
            persons with this disorder have access to quality healthcare. <br/>
          </p>
            
          <p>
            Our awareness projects are carried out to ensure that an increased percentage of persons are tested to know their genotype status.<br/>
            Thus equipping them with the information required to make informed decisions as regards their marital partner and/or offspring(s).<br/> 
          </p>

          <p>
            This awareness forum hopes to truncate the continued inheritance of sickle cell disease and occurrence in Nigeria, reduce child<br/>
            and maternal mortality and eradicate the stigma associated with SCD.<br/>
          </p>

          <p>
            We hope to achieve our objectives by utilizing social media and organize programs aimed at creating awareness<br/>
            on Sickle Cell Disorder.<br/>
          </p>
        </section>

    </div>
  )
}

export default Header